export default __webpack_public_path__ + "static/media/Paws_up_form.986ccf22.jpg";